import React from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'
import * as FPT from '../utility/fpt'

const STYLES = {
	wrapper: {
		// marginTop: '10px',
	},
	toolWrapper: {
		marginTop: '20px',
		position: 'relative'
	},
	toolCheckboxWrapper: {
		position: 'absolute',
		width: 'inherit',
		display: 'inline',
	},
	toolCheckbox: {
		':before': {
			overflow: 'hidden',
		}
	},
	toolBlurb: {
		fontSize: '15px',
		lineHeight: '18px',
		marginLeft: '40px',
		fontFamily: 'pp-sans-small-regular',
	},
	toolTip: {
		position: 'relative',
		display: 'none',
		maxWidth: '430px',
		margin: '5px auto',
	},
	tipIcon: {
		color: '#005EA6',
		cursor: 'pointer',
		textDecoration: 'none',
	},
	toolTipTxt: {
		backgroundColor: '#e1e7eb',
		fontSize: '12px',
		lineHeight: '1.8',
		textAlign: 'left',
		borderRadius: '6px',
		padding: '5px 7px',
		display: 'block',
	}
}

class AddressCheckBox extends React.Component {

	constructor() {
		super();
		this.state = {};
	}

	handleTipClick = (event) => {
		event.preventDefault();
		$('#toolTip').slideToggle('fast')
	}

	handleChangeAddress = (ev) => {
		let isChecked = ev.target.checked;
		let chkBxStatus = isChecked ? 'checked' : 'unchecked';
		FPT.trackLinkClickWithData('shareAddress', { checkbox: chkBxStatus });

		this.props.changeAddress(isChecked);
	}

	render () {
		return (
			<div className="row" style={{ ...STYLES.wrapper }}>
				<div className="col-xs-12 col-sm-12 col-md-12">
					<div style={{ ...STYLES.toolWrapper }}>
						<div className="vx_checkbox" style={{ ...STYLES.toolCheckboxWrapper }}>
							<input type="checkbox" id="accountLegalCheckbox" onChange={this.handleChangeAddress} />
							<label htmlFor="accountLegalCheckbox" style={{ ...STYLES.toolCheckbox }}>
								<span className="sr-only">{this.props.label}</span>
							</label>
						</div>
						<p style={{ ...STYLES.toolBlurb }}>{this.props.label}
							<a href="#" onClick={this.handleTipClick}
								style={{ ...STYLES.tipIcon }}
								className="icon icon-small icon-tooltip-small"
								aria-hidden="true">
							</a>
						</p>
					</div>
				</div>
				<div id="toolTip" className="col-xs-12 col-sm-12 col-md-12" style={{ ...STYLES.toolTip }}>
					<span style={{ ...STYLES.toolTipTxt }}>{this.props.toolTipText}</span>
				</div>
			</div>
		);
	}
}

AddressCheckBox.propTypes = {
	changeAddress: PropTypes.func.isRequired,
	toolTipText: PropTypes.string,
	label: PropTypes.string,
};

export default AddressCheckBox



// WEBPACK FOOTER //
// ./components/addressCheckbox.js